import { queryOptions } from '@tanstack/react-query'

import { LegacyParams } from '@/types/supports'

import { fetchPublishers } from './methods'

const publisherQueryKeys = {
  all: ['publishers'] as const,
  list: (params: LegacyParams) => [...publisherQueryKeys.all, 'list', params] as const
}

export const publisherQueryOptions = {
  list: (params: LegacyParams) =>
    queryOptions({
      queryKey: publisherQueryKeys.list(params),
      queryFn: () => fetchPublishers(params)
    })
}
